import React, { useEffect, useState } from "react";
import LazyLoader from "./LazyLoader";
import { getCertificates } from "../api/api";

function Certification() {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCertificates = async () => {
      const data = await getCertificates();
      if (data.status) {
        setCertificates(data.data); 
      } else {
        console.error("Failed to load certificates:", data.message);
      }
      setLoading(false);
    };
    fetchCertificates();
  }, []);

  return (
    <div className="pt-80 pb-80 bg-[#f8f9fa] w-full">
      <div className="text-center max-w-full mb-8 px-5">
        <h2 className="text-2xl md:text-3xl client-text mb-2">
          <span className="font-semibold">Certifications</span>
        </h2>
        <p className="text-[#2B343B] font-lato">Our Certifications Speak for Us!</p>
      </div>

      <div className="custom-padding xl-screen-padding grid grid-cols-1 md:grid-cols-3 gap-6 w-full mb-10 px-0 justify-items-center">
        {loading ? (
          <p className="text-center text-lg">Loading certificates...</p>
        ) : certificates.length > 0 ? (
          certificates.map((cert, index) => (
            <div 
              key={cert.id} 
              className={`shadow-lg rounded-lg p-5 flex flex-col items-center ${
                index === 1 ? "custom-width-three" : "" 
              }`}
            >
              <div className="rounded-lg mb-4">
                <LazyLoader
                  src={cert.imageUrl} 
                  alt={cert.title}
                  placeholder="#f0f0f0"
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
              <p className="text-center font-medium text-[#636363] client-text">{cert.title}</p>
            </div>
          ))
        ) : (
          <p className="text-center text-lg">No certificates available.</p>
        )}
      </div>
    </div>
  );
}

export default Certification;
